import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { ICoMedicationChecklist, ISaveCoMedicationChecklistRequest } from '../OTP';

export interface ISaveCoMedicationChecklistVariables {
    otpId: number;
    request: ISaveCoMedicationChecklistRequest;
}

export function useSaveCoMedicationChecklist() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<ICoMedicationChecklist, AppMedError, ISaveCoMedicationChecklistVariables>({
        mutationKey: [QueryKeys.otpCoMedications, 'save'],
        mutationFn: async ({ otpId, request }) => {
            return await OTPApi.saveCoMedicationChecklist(otpId, request);
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.otpCoMedications, variables.otpId] });
            notifications.show({
                title: t('otp.coMedication.notifications.saveSuccess.title'),
                message: t('otp.coMedication.notifications.saveSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('otp.coMedication.notifications.saveError.title'),
                message: error?.message || t('otp.coMedication.notifications.saveError.message'),
                color: 'red',
            });
        },
    });
}
